module.exports = __webpack_public_path__ + "7cebce624d1e5996245a3f325db8a7a2.png";